<header class="section-hero-header">
  <div class="padding-global">
    <div class="header-component">
      <div class="margin-bottom margin-xxlarge">
        <div class="text-align-center">
          <div data-w-id="9ec08b96-1a94-30a2-69d8-7c316ea68387" class="max-width-large">
            <div class="margin-bottom margin-small">
              <h1 class="text-color-gradient" i18n="@@wf.hero.title"><br/>Autonomous Revenue Recovery<br/>for <span class="text-no-wrap">E-commerce</span> Growth</h1>
            </div>
            <p class="text-size-medium is-subtitlehero container-small" i18n="@@wf.hero.subtitle">Close sales with <strong>surgical precision</strong>. iCortex™ autonomously <strong>detects purchase intent</strong> and orchestrates <strong>high-fidelity product scenes</strong> to recover unpaid orders.</p>



            <div class="margin-top margin-medium">
              <div class="button-group is-center">
                <a [href]="signupHref" class="button buttonhero w-button" i18n="@@wf.hero.ctaPrimary" (click)="sendGAEvent('Conversion', 'Click', 'Hero Primary CTA')">Activate Autonomous Recovery</a>
                <a href="/technology/lifestyle-engine" class="button is-secondary ishero w-button" i18n="@@wf.hero.ctaSecondary" (click)="sendGAEvent('Navigation', 'Click', 'Hero Lifestyle Engine')">Explore Lifestyle Engine</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div data-w-id="9ec08b96-1a94-30a2-69d8-7c316ea68393" class="hero-header-image-wrapper slide-in-0-6s">
        <div class="hero-image-wrapper">
          <img [src]="heroImageSrc" loading="eager" width="1280" sizes="(max-width: 1280px) 100vw, 1280px" alt="" i18n-alt="@@wf.hero.imageAlt"
               class="hero-header-image"/>
        </div>
        <div data-w-id="9a311e83-ac55-92eb-6806-3276193bed71"
             style="-webkit-transform:translate3d(150%, -300%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(150%, -300%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(150%, -300%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(150%, -300%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
             class="border-light-effect"></div>
      </div>
    </div>
    <div data-w-id="9ec08b96-1a94-30a2-69d8-7c316ea68382" class="container-large">
      <div class="padding-section-large"></div>
    </div>
  </div>
  <div data-w-id="978a1d35-80ef-9c57-5017-85cd52dbd105" class="ellipse-hero"></div>
</header>
